import React from 'react';

const RegisterCircleDecoration = () => (
  <svg width="139" height="49" viewBox="0 0 139 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M138.109 18.172C138.392 21.1476 136.865 24.2325 133.678 27.2816C130.497 30.3258 125.724 33.2707 119.689 35.9457C107.624 41.2936 90.6245 45.5164 71.5528 47.3289C52.4812 49.1415 34.9903 48.1967 22.1343 45.2173C15.7036 43.7269 10.461 41.734 6.76312 39.3435C3.05938 36.9492 0.978314 34.2073 0.695523 31.2318C0.412733 28.2563 1.94001 25.1714 5.12642 22.1223C8.30777 19.078 13.0811 16.1331 19.1159 13.4581C31.1805 8.11026 48.1803 3.88744 67.2519 2.07489C86.3235 0.26233 103.815 1.20716 116.67 4.18655C123.101 5.67687 128.344 7.66984 132.042 10.0603C135.745 12.4546 137.826 15.1965 138.109 18.172Z" stroke="#7462B2" />
  </svg>

);
export default RegisterCircleDecoration;
